interface LoginSDK {
    openLoginDialog: () => Promise<void>
    initSDK: () => Promise<void>
}
let loginSDKPromise: Promise<LoginSDK>;

export function getEurekaLoginSDK(): Promise<LoginSDK> {
    return loginSDKPromise ??= import(`${import.meta.env.VITE_CDN_BASE_URL}/login/login.sdk.es.no-cache.js`);
}
